import { Link } from "react-router-dom";
import { Theme } from "../data/style/Theme";
import { useNavigate } from "react-router-dom";
import * as routes from "../data/links/routes";
import { useEffect, useState, lazy } from "react";
import { GPLogo } from "../components/theme/logos";
import useScreenSize from "../context/ScreenContext";
import {
  AllCenteredColumn,
  CenteredRow,
  MainText,
  MainTitle,
} from "../data/style/Style";

const Box = lazy(() => import("@mui/material/Box"));
const Stack = lazy(() => import("@mui/material/Stack"));

const ErrorPage = () => {
  const navigate = useNavigate();
  const [timer, setTimer] = useState(5);
  const { mobileDevice, size } = useScreenSize();
  var [width] = size;

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer((timer) => timer - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (timer === 0) navigate(routes.LOGIN);
  }, [timer]);

  return (
    <AllCenteredColumn
      height={"100vh"}
      sx={{ background: Theme.palette.background }}
    >
      <CenteredRow width={"100%"}>
        <GPLogo size={72} />
        <Link to={routes.INDEX} style={{ textDecoration: "none" }}>
          <MainTitle
            ml={width < 600 ? 1 : 3}
            fontSize={width < 600 ? "1.2rem" : "1.7rem"}
          >
            GRIND <span style={{ color: Theme.palette.orange }}>PARTNER</span>
          </MainTitle>
        </Link>
      </CenteredRow>

      <Stack
        height={"90%"}
        gap={2}
        width={width < 750 ? "100%" : "50%"}
        minHeight={!mobileDevice && "350px"}
        alignItems={"center"}
      >
        <h1
          style={{
            marginTop: 200,
            width: "80%",
            fontFamily: "Oswald, sans-serif",
            color: Theme.palette.text,
            fontWeight: 900,
            fontSize: "clamp(46px,6.5vw,82px)",
            lineHeight: 0.9,
            letterSpacing: "-0.02em",
            textTransform: "uppercase",
            marginBottom: 22,
            animation: "gpFadeUp .7s ease .12s both",
          }}
        >
          Nothing&nbsp;
          <span className="shimmer-text">Here...</span>
        </h1>
        <Box width={"80%"}>
          <MainText sx={{ color: Theme.palette.muted + " !important" }}>
            The page your are looking for does not exist. You will be redirected
            to the login page in {timer}
          </MainText>
        </Box>
      </Stack>
    </AllCenteredColumn>
  );
};
export default ErrorPage;
